import { getErrorMessage } from '~/utils/errors'

export default defineNuxtRouteMiddleware(async (to) => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.$i18n.locale.value
  const hash = to.params.hash

  try {
    const response = await $fetch<{ status: string; email: string }>(
      `${useBaseUrl()}/user-by-hash/${hash}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    if(!response?.email) {
      return navigateTo(`/${locale}`)
    }
  } catch (error: unknown) {
    console.error('Error fetching user by hash:', getErrorMessage(error))
    return navigateTo(`/${locale}`)
  }

})